import { BarChart, Bar, XAxis, YAxis, Cell, LabelList, ResponsiveContainer } from 'recharts';

// Orders per calendar quarter, with the % change vs the previous quarter under each bar.
// The running quarter is drawn lighter and has no % (it isn't a full quarter yet).
const GrowthChart = ({ data = [], isRtl, height = 280 }) => {
  if (!data.some((d) => d.orders > 0)) {
    return (
      <div className="chart-empty" style={{ height }}>
        <p>{isRtl ? 'لا توجد بيانات نمو بعد' : 'No growth data yet'}</p>
      </div>
    );
  }

  const rows = data.map((d, i) => {
    const prev = i > 0 ? data[i - 1].orders : null;
    const change = !d.isCurrent && prev ? Math.round(((d.orders - prev) / prev) * 100) : null;
    return {
      ...d,
      label: isRtl ? `الربع ${d.quarter} · ${d.year}` : `Q${d.quarter} ${d.year}`,
      change,
    };
  });

  return (
    <div>
      <div style={{ width: '100%', height }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} margin={{ top: 24, right: 8, left: 8, bottom: 0 }}>
            <XAxis
              dataKey="label"
              tick={{ fontSize: 12, fill: 'var(--text-muted)' }}
              stroke="var(--border)"
              tickLine={false}
              reversed={isRtl}
            />
            <YAxis hide />
            <Bar dataKey="orders" radius={[6, 6, 0, 0]} maxBarSize={72}>
              {rows.map((r) => (
                <Cell key={r.label} fill="var(--primary)" fillOpacity={r.isCurrent ? 0.4 : 1} />
              ))}
              <LabelList dataKey="orders" position="top" style={{ fontSize: 13, fontWeight: 600, fill: 'var(--text)' }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: isRtl ? 'row-reverse' : 'row',
          justifyContent: 'space-around',
          marginTop: 8,
          fontSize: 13,
        }}
      >
        {rows.map((r) => (
          <span
            key={r.label}
            style={{
              flex: 1,
              textAlign: 'center',
              fontWeight: 600,
              color: r.isCurrent || r.change === null
                ? 'var(--text-muted)'
                : r.change >= 0 ? 'var(--success)' : 'var(--danger, #c0392b)',
            }}
          >
            {r.isCurrent
              ? (isRtl ? 'جارٍ' : 'in progress')
              : r.change === null
                ? '—'
                : `${r.change >= 0 ? '▲' : '▼'} ${Math.abs(r.change)}%`}
          </span>
        ))}
      </div>
    </div>
  );
};

export default GrowthChart;
